module.exports = {
  baseURL: "https://api.up-skool.com/api/",
  // baseURL : 'http://localhost:6500/api/',
  IMAGE_BASE_URL : "https://api.up-skool.com/uploads/"
};
